export const decodeAudioAtSampleRate = async (
    arrayBuffer: ArrayBuffer,
    sampleRate: number,
): Promise<AudioBuffer> => {
    const offlineContext = new OfflineAudioContext(1, 1, sampleRate);
    return offlineContext.decodeAudioData(arrayBuffer);
};

export const decodeAudioFile = async (file: File): Promise<AudioBuffer> => {
    const arrayBuffer = await file.arrayBuffer();
    const audioContext = new AudioContext();
    try {
        return await audioContext.decodeAudioData(arrayBuffer);
    } finally {
        void audioContext.close();
    }
};

export const decodeAudioFileToChannels = async (file: File): Promise<Float32Array[]> => {
    const audioBuffer = await decodeAudioFile(file);
    const channels = Array<Float32Array<ArrayBuffer>>(audioBuffer.numberOfChannels);
    for (let i = 0; i < audioBuffer.numberOfChannels; i++) {
        channels[i] = audioBuffer.getChannelData(i);
    }
    return channels;
};
